import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, PUBLIC, PUBLIC_JOBS } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${PUBLIC_JOBS}`; 

export const fetchPublicJobDetail = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}`;
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    // console.log("API data", data)
    return data;
  } catch (error) {
    // console.log("error", error);
    const errorMessage = error.message;
  }
};